import { css } from 'emotion'

export const NewInviteFormStyles = css``
